// Import and register all your controllers from within this directory and its subdirectories
import { application } from './application'

import Hello from './hello_controller'
import Theme from './theme_controller'
import SwimmingGuide from './swimming/guide_controller'

application.register('hello', Hello)
application.register('theme', Theme)
application.register('swimming-guide', SwimmingGuide)
